export default __webpack_public_path__ + "static/media/smiling-face.f2705ce4.svg";